import { ModalConfig } from '@shared/interfaces/modal/modal-config';
import { MeterOpenformComponent } from '@shared/modals/meter/meter-openform/meter-openform.component';

export const meterOpenFormWithoutAttachModalConfig: ModalConfig = {
  component: MeterOpenformComponent,
  title: 'meter.createform.create',
  actions: [
    {
      type: 'primary',
      label: 'system.button.save',
      method: 'createMeterWithoutAttach'
    },
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true
    },
  ],
}
